<div class="sk-page" *ngIf="!loading && auftrag">

  <!-- Hero-Kopf -->
  <div class="sk-hero">
    <button mat-icon-button class="sk-back" (click)="back()" aria-label="Zurück zum Stammkunden">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="sk-hero-info">
      <h1>
        {{auftrag.title}}
        <span class="status-chip hero-chip" [attr.data-status]="auftrag.status">{{statusLabels[auftrag.status]}}</span>
      </h1>
      <div class="sk-hero-sub">
        <span><mat-icon class="sk-inline-icon">badge</mat-icon>{{auftrag.customerName}}</span>
        <span *ngIf="auftrag.orderNumber"><mat-icon class="sk-inline-icon">tag</mat-icon>{{auftrag.orderNumber}}</span>
        <span *ngIf="auftrag.location"><mat-icon class="sk-inline-icon">location_on</mat-icon>{{auftrag.location}}</span>
      </div>
    </div>
    <span class="sk-hero-spacer"></span>
    <div class="sk-hero-actions">
      <button mat-raised-button class="sk-btn-light" *ngIf="canManage" (click)="openEinsatzForm()">
        <mat-icon>add</mat-icon> Einsatz planen
      </button>
      <button mat-stroked-button class="sk-btn-ghost" (click)="openPlanung()">
        <mat-icon>calendar_view_week</mat-icon> Planungsboard
      </button>
      <button mat-icon-button class="sk-back" *ngIf="canManage" (click)="editAuftrag()" matTooltip="Auftrag bearbeiten">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>

  <!-- Status-Workflow als Schritte -->
  <div class="sk-card stepper-card">
    <div class="stepper" [class.clickable]="canManage">
      <button class="step" *ngFor="let s of statusSteps; let i = index"
              [class.done]="i < currentStatusIndex"
              [class.current]="i === currentStatusIndex"
              [disabled]="!canManage || statusSaving"
              (click)="setStatus(s)"
              [matTooltip]="canManage ? 'Status setzen: ' + statusLabels[s] : statusLabels[s]">
        <span class="step-dot">
          <mat-icon *ngIf="i < currentStatusIndex">check</mat-icon>
          <span *ngIf="i >= currentStatusIndex">{{i + 1}}</span>
        </span>
        <span class="step-label">{{statusLabels[s]}}</span>
      </button>
    </div>
    <p class="stepper-hint sk-muted" *ngIf="canManage">
      Tipp: Klicke auf einen Schritt, um den Status zu setzen.
    </p>
  </div>

  <!-- Auftragsdaten -->
  <div class="sk-card info-card" *ngIf="auftrag.description || auftrag.receivedDate || auftrag.startDate || auftrag.dueDate || auftrag.primaryWarehouseName">
    <div class="info-grid">
      <div class="info-item" *ngIf="auftrag.receivedDate">
        <label>Auftragseingang</label>
        <span>{{auftrag.receivedDate | date:'dd.MM.yyyy'}}</span>
      </div>
      <div class="info-item" *ngIf="auftrag.startDate">
        <label>Geplanter Beginn</label>
        <span>{{auftrag.startDate | date:'dd.MM.yyyy'}}</span>
      </div>
      <div class="info-item" *ngIf="auftrag.dueDate">
        <label>Fertigstellung bis</label>
        <span>{{auftrag.dueDate | date:'dd.MM.yyyy'}}</span>
      </div>
      <div class="info-item" *ngIf="auftrag.primaryWarehouseName">
        <label>Lager</label>
        <span>{{auftrag.primaryWarehouseName}}</span>
      </div>
    </div>
    <p class="description" *ngIf="auftrag.description">{{auftrag.description}}</p>
  </div>

  <!-- Einsätze nach Tagen -->
  <div class="sk-section-head">
    <h2><mat-icon>event_available</mat-icon> Einsatzplanung ({{assignments.length}})</h2>
    <span class="sk-spacer"></span>
    <button mat-raised-button color="primary" *ngIf="canManage" (click)="openEinsatzForm()">
      <mat-icon>add</mat-icon> Einsatz planen
    </button>
  </div>

  <div class="sk-empty" *ngIf="assignments.length === 0">
    <div class="sk-empty-icon"><mat-icon>event_busy</mat-icon></div>
    <p>Noch keine Einsätze geplant.<br>
      <span class="sk-muted">Plane, wer wann auf dieser Baustelle arbeitet – auf Wunsch mit Kalender-Einladung.</span>
    </p>
    <button mat-raised-button color="primary" *ngIf="canManage" (click)="openEinsatzForm()">
      <mat-icon>add</mat-icon> Ersten Einsatz planen
    </button>
  </div>

  <div class="day-group" *ngFor="let g of dayGroups; trackBy: trackByDay">
    <div class="day-head">
      <mat-icon>today</mat-icon>
      <strong>{{g.day | date:'EEEE, dd.MM.yyyy'}}</strong>
      <span class="sk-muted">{{g.items.length}} {{g.items.length === 1 ? 'Einsatz' : 'Einsätze'}}</span>
    </div>

    <div class="sk-card einsatz-card" [class.sk-card-hover]="canManage"
         *ngFor="let e of g.items; trackBy: trackByEinsatz" (click)="canManage && openEinsatzForm(e)">
      <div class="einsatz-row">
        <div class="einsatz-zeit">
          <strong>{{e.start | date:'HH:mm'}}</strong>
          <span class="sk-muted">– {{e.end | date:'HH:mm'}}</span>
        </div>
        <div class="einsatz-main">
          <div class="einsatz-title-row">
            <strong>{{e.assignedUserName || e.assignedUserId}}</strong>
            <span class="work-chip" [attr.data-status]="e.workStatus">{{workStatusLabel(e.workStatus)}}</span>
            <mat-icon *ngIf="e.inviteSent" class="invite-icon" matTooltip="Kalender-Einladung verschickt">mark_email_read</mat-icon>
          </div>
          <div class="einsatz-meta">
            <span *ngIf="e.title && auftrag && e.title !== auftrag.title">{{e.title}}</span>
            <span *ngIf="e.location"><mat-icon class="sk-inline-icon">location_on</mat-icon>{{e.location}}</span>
            <span *ngIf="e.participantNames.length > 0">
              <mat-icon class="sk-inline-icon">groups</mat-icon>{{e.participantNames.join(', ')}}
            </span>
            <span *ngIf="(e.workerNames ?? []).length > 0">
              <mat-icon class="sk-inline-icon">construction</mat-icon>{{e.workerNames.join(', ')}}
            </span>
            <span *ngIf="(e.materials ?? []).length > 0">
              <mat-icon class="sk-inline-icon">handyman</mat-icon>{{materialSummary(e)}}
            </span>
          </div>
        </div>
        <button mat-icon-button *ngIf="canManage" (click)="deleteAssignment(e, $event)" matTooltip="Einsatz löschen">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Material-Übersicht über alle Einsätze -->
  <ng-container *ngIf="hasMaterials">
    <div class="sk-section-head material-head">
      <h2><mat-icon>handyman</mat-icon> Material</h2>
      <span class="material-badge" *ngIf="materialSubmittedCount > 0">{{ materialSubmittedCount }} zur Freigabe</span>
      <span class="sk-spacer"></span>
      <button mat-stroked-button color="primary" *ngIf="canManage && materialSubmittedCount > 0"
              (click)="approveAllMaterials()">
        <mat-icon>done_all</mat-icon> Alle freigeben
      </button>
      <div class="sk-filter-chips">
        <button class="sk-filter-chip" [class.active]="materialView === 'gesamt'"
                (click)="materialView = 'gesamt'">Gesamt</button>
        <button class="sk-filter-chip" [class.active]="materialView === 'einsatz'"
                (click)="materialView = 'einsatz'">Nach Einsatz</button>
      </div>
    </div>
    <p class="sk-muted material-hint" *ngIf="materialView === 'gesamt' && canManage && materialSubmittedCount > 0">
      Zum Freigeben einzelner Posten in die Ansicht „Nach Einsatz" wechseln.
    </p>

    <!-- Gesamtsummen (gleiches Material zusammengezählt) -->
    <div class="sk-card material-card" *ngIf="materialView === 'gesamt'">
      <div class="material-line" *ngFor="let m of materialTotals">
        <span class="mat-qty">{{m.quantity}} {{m.unit}}</span>
        <span class="mat-name">{{m.name}}</span>
      </div>
    </div>

    <!-- Aufgeschlüsselt nach Einsatz-Terminen -->
    <ng-container *ngIf="materialView === 'einsatz'">
      <div class="sk-card material-card" *ngFor="let g of materialDayGroups; trackBy: trackByDay">
        <div class="material-day-head">
          <mat-icon>today</mat-icon>
          <strong>{{g.day | date:'EEEE, dd.MM.yyyy'}}</strong>
        </div>
        <div class="material-einsatz" *ngFor="let e of g.items; trackBy: trackByEinsatz">
          <div class="material-einsatz-head">
            <mat-icon class="sk-inline-icon">person</mat-icon>
            {{e.start | date:'HH:mm'}} · {{e.assignedUserName || e.assignedUserId}}
            <span *ngIf="e.title && auftrag && e.title !== auftrag.title" class="sk-muted">· {{e.title}}</span>
          </div>
          <div class="material-line" *ngFor="let m of e.materials">
            <span class="mat-qty">{{m.quantity}} {{m.unit}}</span>
            <span class="mat-name">{{m.name}}</span>
            <span class="status-chip time-chip mat-status" [attr.data-status]="m.status || 'Submitted'">
              <mat-icon *ngIf="m.status === 'Locked'" class="sk-inline-icon">lock</mat-icon>
              {{ materialStatusLabel(m.status) }}
            </span>
            <div class="mat-actions" *ngIf="canManage">
              <button mat-icon-button *ngIf="(m.status || 'Submitted') === 'Submitted'"
                      (click)="approveMaterialLine(m, $event)" matTooltip="Material freigeben">
                <mat-icon>check_circle</mat-icon>
              </button>
              <button mat-icon-button *ngIf="m.status === 'Approved'"
                      (click)="reopenMaterialLine(m, $event)" matTooltip="Freigabe zurücknehmen">
                <mat-icon>lock_open</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- Stunden-Übersicht (ohne Preise) -->
  <div class="sk-section-head hours-head">
    <h2><mat-icon>schedule</mat-icon> Stunden</h2>
    <span class="hours-total" *ngIf="hasTimeEntries">{{ totalHours }} h gesamt</span>
    <span class="sk-spacer"></span>
    <button mat-stroked-button color="primary" *ngIf="canManage && submittedCount > 0" (click)="approveAll()">
      <mat-icon>done_all</mat-icon> Alle freigeben ({{ submittedCount }})
    </button>
    <button mat-raised-button color="primary" *ngIf="canManage" (click)="openZeitForm()">
      <mat-icon>add</mat-icon> Stunden erfassen
    </button>
  </div>

  <div class="sk-empty" *ngIf="!hasTimeEntries">
    <div class="sk-empty-icon"><mat-icon>schedule</mat-icon></div>
    <p>Noch keine Stunden erfasst.<br>
      <span class="sk-muted">Der Vorarbeiter meldet die geleisteten Stunden pro Person – hier gibst du sie frei.</span>
    </p>
    <button mat-raised-button color="primary" *ngIf="canManage" (click)="openZeitForm()">
      <mat-icon>add</mat-icon> Stunden erfassen
    </button>
  </div>

  <div class="sk-card hours-card" *ngFor="let g of timeDayGroups; trackBy: trackByDay">
    <div class="hours-day-head">
      <mat-icon>today</mat-icon>
      <strong>{{ g.day | date:'EEEE, dd.MM.yyyy' }}</strong>
      <span class="sk-spacer"></span>
      <span class="hours-day-sum">{{ g.hours }} h</span>
    </div>
    <div class="hours-line" *ngFor="let t of g.items; trackBy: trackByEntry">
      <div class="hours-person">
        <strong>{{ t.personName }}</strong>
        <span class="hours-note sk-muted" *ngIf="t.note">{{ t.note }}</span>
      </div>
      <span class="hours-value">{{ t.hours }} h</span>
      <span class="status-chip time-chip" [attr.data-status]="t.status">
        <mat-icon *ngIf="t.status === 'Locked'" class="sk-inline-icon">lock</mat-icon>
        {{ timeStatusLabel(t.status) }}
      </span>
      <div class="hours-actions" *ngIf="canManage">
        <button mat-icon-button *ngIf="t.status === 'Submitted'" (click)="approveEntry(t, $event)"
                matTooltip="Freigeben">
          <mat-icon>check_circle</mat-icon>
        </button>
        <button mat-icon-button *ngIf="t.status === 'Approved'" (click)="reopenEntry(t, $event)"
                matTooltip="Freigabe zurücknehmen">
          <mat-icon>lock_open</mat-icon>
        </button>
        <button mat-icon-button *ngIf="t.status !== 'Locked'" (click)="openZeitForm(t)"
                matTooltip="Bearbeiten">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button *ngIf="t.status !== 'Locked'" (click)="deleteEntry(t, $event)"
                matTooltip="Löschen">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="sk-loading" *ngIf="loading">
  <mat-spinner diameter="42"></mat-spinner>
</div>
